var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "my_edit_item",
        "my_input_number_wrapper",
        _vm.inline ? "edit_item_inline" : "edit_item_block",
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "input-wrapper",
          style: { width: _vm.inputWidth + "px" },
        },
        [
          _c("el-input-number", {
            ref: "myInputIntNumber",
            staticClass: "my_input_number",
            style: { width: _vm.inputWidth + "px" },
            attrs: {
              size: _vm.size,
              min: _vm.min,
              max: _vm.max,
              step: _vm.step,
              placeholder: _vm.placeholder,
              "controls-position": "right",
              stepStrictly: _vm.stepStrictly,
              disabled: _vm.disabled,
              precision: _vm.precision,
            },
            on: { change: _vm.change_number },
            nativeOn: {
              input: function ($event) {
                return _vm.input_number.apply(null, arguments)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.change_number.apply(null, arguments)
              },
            },
            model: {
              value: _vm.result,
              callback: function ($$v) {
                _vm.result = $$v
              },
              expression: "result",
            },
          }),
          _vm.symbol
            ? _c(
                "i",
                {
                  staticClass: "my-num-symbol",
                  attrs: { slot: "suffix" },
                  slot: "suffix",
                },
                [_vm._v(_vm._s(_vm.symbol))]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "my_title", style: { width: _vm.titleWidth + "px" } },
        [_vm._v(_vm._s(_vm.title))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }